import { Navigate, Outlet } from 'react-router'

import { Breadcrumb } from '@ui/components/navigation'
import { ExtraParams } from '@ui/interfaces/navigation'
import { Teams } from '@ui/pages/settings/Teams'
import { Users } from '@ui/pages/settings/Users'
import { RouteNamesEnum } from '@ui/router/routes'

export const SettingsRoutes = () => {
  return {
    name: RouteNamesEnum.SETTINGS,
    path: 'settings',
    element: <Outlet />,
    handle: {
      crumb: (data: ExtraParams) => <Breadcrumb crumbStyle={data.crumbStyle} to="/settings" label="Settings" />,
    },
    children: [
      {
        index: true,
        element: <Navigate to="users" replace />,
      },
      {
        name: RouteNamesEnum.SETTINGS_USERS,
        path: 'users',
        element: <Users />,
      },
      {
        name: RouteNamesEnum.SETTINGS_TEAMS,
        path: 'teams',
        element: <Teams />,
      },
    ],
  }
}
